<template>
  <div class="protocol-results">
    <div :id='protocol._id' class="protocol">
        <router-link :to='link' tag="h2">
          <a>{{ info(protocol, "title") }}</a>
        </router-link>
        <div id="time" v-if="info(protocol,'time-estimate')"><span>{{ info(protocol,'time-estimate') }}</span></div>

      <p id="author">
       <span>Author: {{ info(protocol, "author") }} </span>

        <span v-if="info(protocol, 'partner')">| Partner: {{ info(protocol, "partner") }} </span>
      </p>
      <p>{{ info(protocol, 'description') }}</p>
    </div>
  </div>
</template>

<script>
  import { scrubMixin } from '../mixins'
  export default {
    name: 'ProtocolPreview',
    mixins: [scrubMixin()],
    props: ['protocol'],
    data () {
      return {
      }
    },
    computed: {
      link () {
        return {
          name: 'protocol',
          params: {
            slug: this.protocol._source.slug
          }
        }
      }
    },
    methods: {
      info (protocol, key) {
        return protocol._source[key]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ProtocolPreview.vue?1680ade5